import { decodeAccessToken } from '../decode-access-token'

export interface Session {
  isUserAuthenticated: boolean
  isUserRoot: boolean
  userId: string | null
}

export const EMPTY_SESSION: Session = {
  isUserAuthenticated: false,
  isUserRoot: false,
  userId: null,
}

export const buildSessionState = (): Session => {
  const claims = decodeAccessToken()

  if (!claims) return EMPTY_SESSION

  return {
    isUserAuthenticated: true,
    isUserRoot: claims.is_root,
    userId: claims.sub,
  }
}
